module.exports = __webpack_public_path__ + "static/media/logo.5a7665f6.png";